
// do lazy sizes
import { getLazySizesConfig } from '../SiteConfigs.js';

import { deleteCookie, eraseCookie } from '../Utility/CookieManager.js';
import lazySizes from 'lazysizes';
lazySizes.cfg = Object.assign(lazySizes.cfg, getLazySizesConfig());
window.deleteCookie = deleteCookie;
window.eraseCookie = eraseCookie;

const RefreshAds = () => import(/* webpackChunkName: "RefreshAds" */ "./RefreshAds.js");
const FloatingAds = () => import(/* webpackChunkName: "FloatingAds" */ "./FloatingAds.js");

window.ads_refresh = {};

function loadAds() {
    console.log('ADMIRAL all_ads_disabled: ', (typeof all_ads_disabled));
    console.log('ADMIRAL evolok_init_finished: ', evolok_init_finished);
    console.log('ADMIRAL evolok_do_ads: ', evolok_do_ads);
    console.log('ADMIRAL evolok_block_ads: ', evolok_block_ads);
    console.log('ADMIRAL allow_ad_render: ', allow_ad_render);
    console.log('ADMIRAL network_ads_loaded: ', network_ads_loaded);

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        console.log("ADMIRAL allAds all_ads_disabled");
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads && !evolok_block_ads) {
            console.log("ADMIRAL allAds !evolok_block_ads", evolok_block_ads);
            // Just skip and wait for next function call for a status change
            return;
        } else if(evolok_block_ads) {
            console.log("ADMIRAL allAds evolok_block_ads", evolok_block_ads);
            return;
        }

        // Otherwise go ahead and do ads
    }

    if(!allow_ad_render) {
        console.log("ADMIRAL allAds allow_ad_render", allow_ad_render);
        return;
    }

    if(network_ads_loaded) {
        console.log("ADMIRAL allAds network_ads_loaded", network_ads_loaded);
        return;
    }

    if( typeof timer_ad_load !== 'undefined' ){
        var timer_now = (new Date()).getTime() / 1000;
        console.trace('ADMIRAL TIMER - '+(timer_now - window.timer_ad_load)+' sec - loadAds() successfully run');
    }

    network_ads_loaded = true;

    console.log("ADMIRAL RUN G ADS");

    // Track how many page hits by users in their two-week adfree trial
    if( readCookie('two_weeks_adfree') ){

        var check_send_ga_loaded = setInterval(function(){
            if( typeof send_notifier_event == 'function' ){
                var onload_adfree_user_data = {
                    'ge_action' : 'Page Load No Ads',
                    'ge_category' : 'Two Weeks Ad-Free Promo',
                    'ge_label' : 'Adblock User Subscribed to Newsletter',
                    'ge_index' : null,
                    'ge_noninteraction' : true
                };
                send_notifier_event(onload_adfree_user_data);

                clearInterval(check_send_ga_loaded);
            } //if func() exists check
        }, 250); //2.5 Second Intervals

        return false;
    }

    if(SITE_INFO['name'] == 'markets' && !NO_IC) {

        investingChannel_init();
        return;

    }

    // console.log("REFRESH ADS", RefreshAds);
    RefreshAds()
    .then(refresh => {
        // console.log("ADS REFRESH ", refresh);
        ads_refresh = refresh.default;
        ads_refresh.auto_refresh_ads_service();
    });

    // TRIGGER HOMEPAGE FLOATING ADS CODE
    if( $("body").hasClass("home") ){

        if( SITE_INFO['name'] == 'politics' ){
            var isMobile = $().isMobile();
            if(!(isMobile)){ //ONLY DESKTOP/TABLET we float ads

                var adOpts = {};

                if( $('body').hasClass('with-distroscale') || $('body').hasClass('with-ora') ){
                    adOpts.banner = false;
                }

                adOpts.box_top = false;

                FloatingAds()
                .then(module => {
                    window.floatAds = new module.default(adOpts);
                    window.floatAds.init();
                });
            }

        }else if(SITE_INFO['name'] == 'defense'){

            // FloatingAds()
            // .then(module => {
            //     window.floatAds = new module.default({mobile_box_top: false});
            //     window.floatAds.init();
            // });
        }

    }

    if( LAZY_ADS_ENABLED ) {
        start_lazy_ads();
    } else {
        normal_ads_load();
    }
}

function start_lazy_ads() {
    console.log("ADMIRAL: start_lazy_ads");

    // Show all ads that are marked with class .RC-AD-SHOW-NOW instead of .RC-AD
    var show_now_elements = document.querySelectorAll('.RC-AD-SHOW-NOW');

    for (var i = 0; i < show_now_elements.length; i++) {

        var show_now = show_now_elements[i];

        for (var ad_slot in ads_info) {
            // if(ad_slot.dont_refresh == true){
            //     console.log(ad_slot);
            //     return;
            // }
            if (ads_info.hasOwnProperty(ad_slot)) {

                if( !ads_info[ad_slot]['loaded'] &&
                    hasClass(show_now, ads_info[ad_slot]['class']) &&
                    isVisible(show_now) ) {

                    lazy_ad_list.push(ad_slot); // adds ad to list of ads to render (if ready)
                    ads_info[ad_slot]['loaded'] = true;
                }
            }
        }
    }

    if(show_now_elements.length>0){
        //REVERSE ORDER OF SHOW-NOW ADS - IN ORDER FOR ABF ADS TO LOAD FIRST        
        lazy_ad_list.reverse();
    }    

    // We push ad slots to a list. This is because the above-the-fold ads may be
    // visible to lazyload library before our publir prebid is ready
    document.addEventListener('lazybeforeunveil', function(e) {

        console.log("ADMIRAL lazybeforeunveil", e);

        for (var ad_slot in ads_info) {
            // if(ad_slot.dont_refresh == true){
            //     console.log(ad_slot);
            //     return;
            // }
            if (ads_info.hasOwnProperty(ad_slot)) {

                if( !ads_info[ad_slot]['loaded'] &&
                    hasClass(e.target, ads_info[ad_slot]['class']) &&
                    isVisible(e.target) &&
                    !hasClass(e.target, '.RC-AD-SHOW-NOW') ) {

                    // Record of all ad slots that have been visible to user
                    lazy_ad_list.push(ad_slot); // adds ad to list of ads to render (if ready)
                    ads_info[ad_slot]['loaded'] = true;

                    // console.log('ad pushed into ad render list', ads_info[ad_slot]);
                    break;
                }
            }
        }
    });

    lazySizes.init();

    // moved here to only call once instead on every ad render
    googletag.cmd.push(function () {
        console.log("ADMIRAL CALL INIT GOOGLE TAG");
        init_googletag();
    });

    console.log("ADMIRAL lazy_ad_list", lazy_ad_list);

    var lazy_ad_interval = window.setInterval(function() {

        // console.log("ADMIRAL ads setInterval, lazy_ad_list_length lazy_ad_list", lazy_ad_list.length, lazy_ad_list);

        //console.log('lazy check... length: '+lazy_ad_list.length);

        if( lazy_ad_list.length == 0 || !allow_ad_render || browser_tab_is_visible == false) {
            return;
        }

        // Find first ad_slot that is actually visible on screen and load
        // In theory this shouldn't be neccessary... not sure why lazysizes is getting false positives sometimes

        var target_ad_i = lazy_ad_list.length - 1;
        var match_found = false;

        for (var i = 0; i < lazy_ad_list.length; i++) {

            var ad_elem = firstVisibleElement('.'+ads_info[lazy_ad_list[i]]['class']); // first visible element

            //if( ad_elem == null || !isVisibleOnScreen(ad_elem) ) { // must be visible on screen
            if( ad_elem == null ) { // must have match
                continue;
            } else {
                target_ad_i = i;
                match_found = true;
            }
        }

        if( !match_found ) {
            return; // Don't do unless truly visible on screen
        }

        // Removes and returns ad name from stack that has been accumulating
        var temp_ad_slots = lazy_ad_list.splice(target_ad_i, 1);
        var ad_slot = temp_ad_slots[0];

        if(ad_slot){
            // if(ad_slot.dont_refresh == true){
            //     console.log(ad_slot);
            //     return;
            // }

            // console.log("ADMIRAL load ad_slot", ad_slot);

            googletag.cmd.push(function () {

                // moved above to only call once
                // init_googletag();

                //// Create and serve prebid ad
                rcmg_load_ad(ad_slot, 'lazy');
            });
        }

    }, 50); // Checks every 50 milliseconds
}

function rcmg_load_ad(ad_slot, load_type) {

    // If politics homepage and 160x600_top (shows below left col)
    if(SITE_INFO['name'] == 'politics' && sitePage=='home' && ad_slot == 'div-gpt-ad-1390595004947-2') {
        // 8/5/2022 all day, disable
        var now_ts = Date.now()/1000;
        if(now_ts > 1659672000 && now_ts < 1659758400) { return; }
    }

    // if(ad_slot.dont_refresh == true){
    //     console.log(ad_slot);
    //     return;
    // }

    // console.log("ADMIRAL rcmg_load_ad: ", ad_slot, load_type);

    if(typeof load_type === 'undefined') { load_type = 'normal'; }// Get only first visible element that matches

    var ad_elem = firstVisibleElement('.'+ads_info[ad_slot]['class']); // first visible element
    //var ad_elem = document.querySelector('.'+ads_info[ad_slot]['class']); // default element is just first matching class
    if(ad_elem == null) {
        console.log('no container found for: '+ads_info[ad_slot]['class']);
        return; // no ad container found
    }
    /*var matches = document.querySelectorAll('.'+ads_info[ad_slot]['class']);
  for (var i = 0; i < matches.length; ++i) {
    if(isVisible(matches[i])) {
      ad_elem = matches[i];
      break;
    }
  }*/

    // If ad has been closed recently, do not load
    if( readCookie(ad_close_cookie_name(ad_elem)) ) {
        return;
    }

    // If investingchannel override, and on relevant site, put script tag in and return
    if( SITE_INFO['name'] == 'markets' && !NO_IC && typeof ads_info[ad_slot]['ic_override'] !== 'undefined' && ads_info[ad_slot]['ic_override'].length > 2 ) {


        return;

        /*if($('body').hasClass('new_ic_uat') ){
            return;
        }*/

        /*var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = ads_info[ad_slot]['ic_override'];
        s.charset = "utf-8"
        ad_elem.appendChild(s);
        return;*/
    }

    var slot_sizes = ads_info[ad_slot]['sizes'];

    /*custom filter for disallowed slot sizes on certain pages*/
    var filtered_slot_sizes = []; //
    slot_sizes.forEach(function (item, index) {
        /*DO NOT Allow 970s on top-leaderboard homepage placements */
        if(ads_info[ad_slot]['class']=='RC-AD-TOP-BANNER' && sitePage=='home' && item[0]=='728'){ //ONLY ALLOW 728 ON HOMEPAGE            
            filtered_slot_sizes.push(item);
        }

        var isMobile = $().isMobile();        
        if(ads_info[ad_slot]['class']=='RC-AD-BOX-TOP' && isMobile==true && item[1]=='250' && (sitePage=='polls' || sitePage=='home') ){ //ONLY ALLOW 250 height ads on Polls or HP Mobile           
            filtered_slot_sizes.push(item);
        }     

    });

    if(filtered_slot_sizes.length>0){ slot_sizes = filtered_slot_sizes; } //IF FILTERED REPLACE DEFAULT VAR
    
    var new_slot = googletag.defineSlot(ads_info[ad_slot]['name'], slot_sizes, ad_slot).addService(googletag.pubads());
    ads_info[ad_slot].slot_definition = new_slot;

    // console.log(ad_elem);
    //console.log(pbjs.adUnits);

    //ad_elem.innerHTML = "<div id='"+ad_slot+"'></div>";

    // Use this method to append... so we don't overwrite any close button
    var new_ad_div = document.createElement('div');
    new_ad_div.id = ad_slot;
    ad_elem.appendChild(new_ad_div);

    // if( !PREBIDDING_ENABLED ){
    //     console.log('ADMIRAL NO PREBID DISPLAY SLOT');
        googletag.display(ad_slot);
    // }

    // console.log(ad_elem.innerHTML);

    if(load_type == 'lazy') {

        // After each ad, since lazy
        // But before unit refresh
        if(typeof window.moatAPI !== 'undefined') {
            window.moatAPI.init();
        }

        if(PREBIDDING_ENABLED) {
            console.log('ADMIRAL PREBID ENABLED');

            /*
        pbjs.que.push(function() {
            pbjs.setTargetingForGPTAsync();
            googletag.pubads().refresh([ new_slot ]);
        });*/

            pbjs.que.push(function() {
                pbjs.requestBids({
                    timeout: PREBID_TIMEOUT, //set by publir
                    adUnitCodes: [ad_slot],
                    bidsBackHandler: function() {
                        console.log('ADMIRAL PREBID DISPLAY SLOT');
                        pbjs.setTargetingForGPTAsync([ad_slot]);
                        // googletag.display(ad_slot);
                        googletag.pubads().refresh([new_slot]);
                    }
                });
            });

        } else {
            console.log('loading lazy ad no prebid');
            if(SITE_INFO['name'] != 'markets' || NO_IC) {
                
                googletag.pubads().refresh([ new_slot ]);
            }
        }

    }

    setAdCloser(ad_slot);
    addStylesToAds();
}

// Global requirements: ads_info, googletag
function normal_ads_load() {

    console.log('normal_ads_load()');

    // Load ads normally
    googletag.cmd.push(function () {

        init_googletag();
        //try { amznads.setTargetingForGPTAsync('amznslots');} catch(e) { /*ignore*/}

        //googletag.pubads().collapseEmptyDivs(true);

        //googletag.pubads().refresh();

        for (var ad_slot in ads_info) {
            // if(ad_slot.dont_refresh == true){
            //     console.log(ad_slot);
            //     return;
            // }
            if (ads_info.hasOwnProperty(ad_slot)) {
                rcmg_load_ad(ad_slot);
            }
        }

        if(!PREBIDDING_ENABLED) {
            googletag.pubads().refresh();
        } else {
            pbjs.que.push(function() {
                pbjs.requestBids({
                    timeout: PREBID_TIMEOUT, //set by publir
                    bidsBackHandler: function() {
                        pbjs.setTargetingForGPTAsync();
                        googletag.pubads().refresh();
                    }
                });
            });
        }

    });
}

/**
 * Requirements: must be called within a googletag.cmd.push(function() {}) block
 * @see https://developers.google.com/doubleclick-gpt/reference
 */
function init_googletag() {
    console.log("ADMIRAL INIT GOOGLE TAG", googletag);

    googletag.pubads().setTargeting("SiteDomain", SITE_INFO['name']);
    googletag.pubads().setTargeting("SitePage", SITE_PAGE);
    googletag.pubads().setTargeting("Tags", GA_TAG);

    // Used to send keywords to google ads
    if(typeof DYNAMIC_GAM_KEYWORDS !== 'undefined') {
        eval("googletag.pubads().setTargeting('Keywords', DYNAMIC_GAM_KEYWORDS)");
    }

    googletag.pubads().addEventListener('slotRenderEnded', function(event) {
        var slot_path = event.slot.getAdUnitPath();
        
        console.groupCollapsed('ADMIRAL AD RENDERED: '+slot_path+' SEC: '+(new Date().getSeconds()));
        console.trace("ADMIRAL AD RENDERED", slot_path, event);
        console.groupEnd();

        //IF WE'RE LOADING A 970 ON POLLS DESKTOP WE MUST ADJUST CSS TO FIT PROPERLY
        if(slot_path=='/1004503/RC_728_by_90_top' && sitePage=='polls' && event.size[0]=='970'){                 
            $(".top-banner").css("overflow","visible");
            $(".RC-AD-TOP-BANNER").css("float","right");            
        }
        //jw player cookie gets erased if the ad is displayed and the id matches
        //@see https://developers.google.com/publisher-tag/reference#googletag.events.SlotRenderEndedEvent_lineItemId
        if(slot_path=='/1004503/RC_1_by_1_tynt' && event.lineItemId == '6110397268'){                 
            eraseCookie('jw_player_shown_new');
        }

        if(slot_path=='/1004503/RC_1_by_1_tynt' && event.lineItemId == '6131302515'){                 
            createCookie("show_dst_instead", "1", 30, false);
        }

        if(slot_path=='/1004503/RC_mobile'){
            var mobile_slot_id = event.slot.getSlotElementId();
            var mobile_element = document.getElementById(mobile_slot_id);               

            if(event.isEmpty){ //GAM lets us know if ad event is empty
                if(!$(mobile_element).parent().hasClass('noAd')){
                    $(mobile_element).parent().addClass('noAd');  
                }            
            }else{
                if($(mobile_element).parent().hasClass('noAd')){
                    $(mobile_element).parent().removeClass('noAd');  
                }                
            }
        }        
        
        //set ad container min-height to reduce shifting page with incoming ad-refreshes        
        if(!event.isEmpty){
            var renderedAdElement_id = event.slot.getSlotElementId();
            var renderedAdElement = document.getElementById(renderedAdElement_id);            
            var parent = $(renderedAdElement).parent();
            $(parent).css("min-height",""+event.size[1]+"px");

            // console.log("SLOT PATH", slot_path);
            // trigger PA entries to show
            if( slot_path == '/'+AD_ID+'/RC_Lc' ){
                // console.log("SLOT PATH FOR LC TRIGGERED");
                $('.pa-post-wrapper').show();
            }
        }
        
        /**
         * Add ads to the refresh queueu after they've been rendered
         */
        // console.log("ADD AD TO ADS REFRESH", slot_path, ads_refresh, event);
        if( typeof ads_refresh.add_to_refresh_queueu !== 'undefined' ){
            ads_refresh.add_to_refresh_queueu(event);
        }

    });    
    
    googletag.pubads().disableInitialLoad();
    googletag.pubads().collapseEmptyDivs(true);
    googletag.enableServices();
}

// // Ad Closing //////////////////////////////////////////////////////////////////

function setAdCloser(ad_slot){
    // if(ad_slot.dont_refresh == true){
    //     console.log(ad_slot);
    //     return;
    // }

    //Check if the Ad should be closed
    if(shouldAdHaveCloser(ad_slot) == false) {
        return;
    }

    var interval_key = setInterval(function(){
        var $el = $("." + ads_info[ad_slot]['class']);
        if($el.length > 0){

            clearInterval(interval_key);

            var closer = '<div class="close-the-ad">&times;</div>';

            if($el.hasClass('RC-AD-MOBILE-BANNER')){
                if( !$el.hasClass("noAd") ){ //we've determined ad slot is empty, no need for closer
                    $el.append(closer);
                }
            }else{
                $el.addClass('rc-ad-top-banner-reactive').append(closer);
            }

            //alert('here');

            $el.find('.close-the-ad').click(function() {
                // $(this).parent().parent().hide();
                // $(this).closest('.RC-AD').hide();

                // on closing ad, create a cookie based on the classes of the element
                // the cookie is to be used by anyone else needing to check for this
                //var ad_element = $(this).closest('.RC-AD');
                var ad_element = $(this).parent();
                var cookie_name = ad_close_cookie_name(ad_element);
                createCookie(cookie_name, $(ad_element).prop('nodeName')+'_'+cookie_name, 1);
                $(ad_element).hide();
            });
        }

    }, 1000);
}

function ad_close_cookie_name(ad_element) {
    return Utils.make_slug($(ad_element).attr('class')+'_close-ad');
}

/*Adding inline styles to Ad*/
function addStylesToAds(){

    $.each(ads_info, function( key, value){

        if(typeof value.styles !== 'undefined' && value.styles.length !== 0){
            $('.'+ value.class + '> div').css(value.styles);
        }

    });

}

//Check if ad Exist 11/15/2018
function shouldAdHaveCloser(ad_slot){
    // if(ad_slot.dont_refresh == true){
    //     console.log(ad_slot);
    //     return;
    // }
    var ad_option = ads_info[ad_slot];

    if(ad_option.closeable_pages.length == 0){
        return false;
    }

    for (let i = 0; i < ad_option.closeable_pages.length; i++) {

        var class_txt = ad_option.closeable_pages[i];
        if( $('body').hasClass(class_txt) ) {

            return true;
        }

    }
}

export default loadAds;